import React from 'react';

import { Separator } from '@components/formStyles';
import Typography from '@components/Typography';

import { DesktopContainer } from './RulesStyle';
import RulesBodyDesktop from './RulesBodyDesktop';

export interface RulesProps {
  checkinBeginTime?: string;
  checkinEndTime?: string;
  optionalFee?: string;
  checkoutTime?: string;
  mandatoryFee?: string;
  checkinInstruction?: string;
  checkinSpecialInstruction?: string;
}

const RulesDesktop = ({
  mandatoryFee = '',
  optionalFee = '',
  checkinEndTime = '',
  checkinBeginTime = '',
  checkoutTime = '',
  checkinInstruction = '',
  checkinSpecialInstruction = '',
}: RulesProps) => {
  return (
    <DesktopContainer>
      <Typography variant='Title4' color='darkGrey' weight='Bold'>
        Giriş-Çıkış ve Önemli Bilgiler
      </Typography>
      <RulesBodyDesktop
        checkinBeginTime={checkinBeginTime}
        checkinEndTime={checkinEndTime}
        checkoutTime={checkoutTime}
        optionalFee={optionalFee}
        mandatoryFee={mandatoryFee}
        checkinInstruction={checkinInstruction}
        checkinSpecialInstruction={checkinSpecialInstruction}
      />
      <Separator />
    </DesktopContainer>
  );
};

export default RulesDesktop;
